// Wraps any route element. If the visitor is not signed in, redirect to /login.
// While the session check is in flight, render a soft loading card so the UI
// does not flash signed-out state. Composes per-route, so adding a public-but-
// personalised route later does not fight the layout.

import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { useSession } from "../lib/auth";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { data: session, isPending } = useSession();
  const location = useLocation();

  if (isPending) {
    return <SessionLoading />;
  }
  if (!session) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}

function SessionLoading() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "64px 24px",
        color: "rgb(var(--color-ink-muted))",
        fontSize: 14,
      }}
    >
      <span>Loading your session...</span>
    </div>
  );
}
